<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="22">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                        <el-form-item label="缺货日期">
                            <el-date-picker
                                    v-model="pickDate"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="商品" >
                            <el-select v-model="formInline.productId" clearable filterable  placeholder="选择商品">
                                <el-option
                                        v-for="item in productList"
                                        :key="item.proId"
                                        :label="item.proName"
                                        :value="item.proId">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item >
                            <el-button type="success" size="mini" @click="getCardPlan">查询</el-button>
                        </el-form-item>
                        <!--<el-form-item >-->
                            <!--<el-button type="success" size="mini" @click="downloadCardPlan">导出</el-button>-->
                        <!--</el-form-item>-->
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="province" label="省" width="120"></el-table-column>
            <el-table-column prop="city"   label="市" width="120"></el-table-column>
            <el-table-column prop="area"   label="区" width="120" ></el-table-column>
            <el-table-column prop="pickupDate"   label="提货日期" width="200" ></el-table-column>
            <el-table-column prop="productName"   label="商品名称" width="200" ></el-table-column>
            <el-table-column prop="quantity" label="数量" width="60"></el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getOutStockList,downCardPlanApi,getProducts} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    productId:'',
                    currentPage: 1,
                    pageSize: 20,
                    recordsTotal: 0,
                    start:'',
                    end:'',
                },
                showDialog: false,
                loading: true,
                pickDate:[],
                list: [],// 缺货信息
                productList:[],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            end.setTime(end.getTime() + 3600 * 1000 * 24 * 3);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近七天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value1: '',
                value2: ''
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
            getProducts({}).then((res) => {
                console.log(res);
                this.productList = res.data.value;
            })
        },
        methods: {
            getList(){
                this.loading = true;
                if(this.pickDate!=''&&this.pickDate!=null){
                    this.formInline.start=this.pickDate[0];
                    this.formInline.end=this.pickDate[1];
                }else {
                    this.formInline.start='';
                    this.formInline.end='';
                }
                getOutStockList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            downloadCardPlan(){
                window.open(`${downCardPlanApi}?cardId=${this.formInline.cardId}&status=${this.formInline.status}&start=${this.formInline.start}&end=${this.formInline.end}&pageRouterUrl=prizelist`)
            },
            getLink(orderMainNo){
                let returnUrl = ''
                returnUrl = `${window.location.origin}/#/queryorder?orderMainNo=${orderMainNo}`
                return returnUrl
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },
            formatdate(row, column, cellValue){
                if(cellValue==null){
                   return cellValue;
                }
                return cellValue.split(" ")[0];
            },
            GetQueryString(name){
                let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                let sp = '?'
                let arr=window.location.href.split(sp);
                if(arr.length>=2){
                    let u=arr[1].substr(1);
                    u= u.replace(/amp;/g,"");
                    let r = u.match(reg);
                    if(r!=null)
                        return  decodeURIComponent(r[2]);
                }
                return(false);
            }
        },

    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/order/outStock.vue